import setGhostImage from '../../../../LeftPane/setGhostImage';
import collapseHandler from '../utils/setCollapse';
import setScrollOnCardDragStart from './setScrollOnCardDragStart';

export default async (params) => {
  const { e, dragType } = params;

  const el = e.target;

  el.classList.add('dragging');

  // @layer2 Create well formed data URL with our DOM string wrapped in SVG
  setGhostImage({ e, el });

  if (dragType === 'ROLE_ARRAY_ITEM' || dragType === 'ARRAY_ITEM') {
    setTimeout(() => {
      el.style.display = 'none';
    }, 0);

    const { setDrag } = params;
    setDrag({ dragType });
  } else {
    const { editor, collapse, nodeKey, setCollapse, setSnackBar } = params;

    collapseHandler({
      el,
      editor,
      collapse,
      setCollapse,
      collapseVal: true,
      dragType,
      setSnackBar,
    });

    /**
     * For the current dragging element
     */
    setScrollOnCardDragStart({ nodeKey, editor });
  }
};
